/*
 * Product-page gallery filtering by color variant.
 *
 * Shopify's native "hide unselected variant media" (main-product section's
 * hide_variants setting) can only ever hide/show ONE image per variant —
 * productVariantAppendMedia hard-caps a variant at a single attached media
 * item, there's no platform way around it. That's not enough when a color
 * has several photos: everything beyond that one image falls into Shopify's
 * "not attached to any variant" bucket and stays visible for every variant.
 *
 * This reads the product's custom.color_media_ids metafield (color label ->
 * every media ID for that color, written at import time) and does the full
 * show/hide pass itself: on variant change, show only the selected color's
 * photos, hide every other color's, and scroll the first shown photo into
 * view. Runs on top of Dawn's native gallery, not instead of it.
 *
 * This theme's gallery is the older Dawn <slider-component> structure (not
 * the newer <media-gallery> custom element), so slides are plain
 * `<li class="product__media-item" data-media-id="{sectionId}-{mediaId}">`
 * elements — no <media-gallery> wrapper to query. Match on that directly.
 */
(function () {
  function extractNumericId(rawId) {
    if (!rawId) return null;
    var m = rawId.match(/(\d+)$/);
    return m ? m[1] : null;
  }

  function getColorMediaIds(productInfo) {
    var script = productInfo.querySelector('[data-color-media-ids-json]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function getColorOptionKey(productInfo) {
    var script = productInfo.querySelector('[data-color-media-ids-json]');
    var position = script && script.dataset.colorOptionPosition;
    return 'option' + (position || '2');
  }

  function applyColorFilter(productInfo, colorMediaIds, color) {
    if (!color) return;

    var items = Array.prototype.slice.call(
      productInfo.querySelectorAll('.product__media-item[data-media-id]')
    );
    if (!items.length) return;

    var ids = colorMediaIds[color];
    if (!ids || !ids.length) {
      // No grouping data for this color (metafield missing/stale for it) —
      // leave the gallery as Dawn's native logic already set it up, rather
      // than hiding everything.
      items.forEach(function (item) {
        item.hidden = false;
        item.style.display = '';
      });
      return;
    }

    var idSet = {};
    ids.forEach(function (id) { idSet[String(id)] = true; });

    var firstMatch = null;
    items.forEach(function (item) {
      var numericId = extractNumericId(item.dataset.mediaId);
      var show = numericId && idSet[numericId];
      item.hidden = !show;
      item.style.display = show ? '' : 'none';
      if (show && !firstMatch) firstMatch = item;
    });

    if (firstMatch && firstMatch.scrollIntoView) {
      firstMatch.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  function initProductInfo(productInfo) {
    var colorMediaIds = getColorMediaIds(productInfo);
    if (!Object.keys(colorMediaIds).length) return; // nothing to filter — no-op

    var sectionId = productInfo.dataset.section;
    var colorOptionKey = getColorOptionKey(productInfo);

    function run(variant) {
      if (!variant) return;
      applyColorFilter(productInfo, colorMediaIds, variant[colorOptionKey]);
    }

    // Initial state: whichever variant the page loaded with.
    var selectedVariantEl = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (selectedVariantEl) {
      try {
        run(JSON.parse(selectedVariantEl.textContent));
      } catch (e) {}
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.sectionId === sectionId) {
          run(event.data.variant);
        }
      });
    }
  }

  function init() {
    var nodes = document.querySelectorAll('product-info');
    for (var i = 0; i < nodes.length; i++) initProductInfo(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
